import { useState } from 'react';
import { useIntl } from 'react-intl';
import { IconCustomExport } from '@rossum/ui/icons/tabler';
import {
  CircularProgress,
  IconButton,
  IconButtonProps,
  Menu,
  MenuItem,
  SvgIcon,
} from '@rossum/ui/material';

export const FORMATS = ['csv', 'json', 'xlsx'] as const;
export type DownloadFormat = (typeof FORMATS)[number];

type DownloadFormatsSelectProps = {
  onClick: (format: { format: DownloadFormat }) => void;
  loading?: boolean;
} & Omit<IconButtonProps, 'onClick'>;

export const ExportButton = ({
  onClick,
  loading,
  ...iconButtonProps
}: DownloadFormatsSelectProps) => {
  const [anchor, setAnchor] = useState<HTMLElement | null>(null);
  const intl = useIntl();

  return (
    <>
      <IconButton
        {...iconButtonProps}
        onClick={e => setAnchor(e.currentTarget)}
      >
        {loading ? (
          <CircularProgress size={24} color="inherit" />
        ) : (
          <SvgIcon fontSize="large">
            <IconCustomExport />
          </SvgIcon>
        )}
      </IconButton>
      <Menu
        anchorEl={anchor}
        open={Boolean(anchor)}
        onClose={() => setAnchor(null)}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'right',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
      >
        {FORMATS.map((format: DownloadFormat) => (
          <MenuItem
            key={format}
            onClick={() => {
              onClick({ format });
              setAnchor(null);
            }}
          >
            {intl.formatMessage({ id: `features.datasets.formats.${format}` })}
          </MenuItem>
        ))}
      </Menu>
    </>
  );
};
